import { Building01Icon, User01Icon, UsersIcon } from '@forwardflow/icons'
import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { Group, Stack } from '@forwardflow/ui-v2'

const iconMap = {
   'Solo Agent': User01Icon,
   'Small Team (2-10 agents)': UsersIcon,
   'Enterprise (Unlimited users)': Building01Icon,
}

export const SelectedTierCard = () => {
   const { onboardingData } = useOnboardingStoreV2()
   const { selectedTier, planPeriod } = onboardingData
   const SelectedIcon = iconMap[
      selectedTier?.tierName as keyof typeof iconMap
   ] as React.ElementType

   const selectedPriceText = `$${(
      (planPeriod === 'monthly'
         ? selectedTier?.monthlyPrice ?? 0
         : selectedTier?.annualPrice ?? 0) * (selectedTier?.includedSeats ?? 1)
   )?.toLocaleString('en-US')}`

   const selectedPeriod = planPeriod === 'monthly' ? 'month' : 'year'

   return (
      <Group justify="space-between">
         <Group>
            <Group
               justify="center"
               align="center"
               className="w-12 h-12 rounded-lg border border-[#8E51FF] bg-gradient-to-br from-[#4F39F6]/30 to-[#7F22FE]/30"
            >
               <SelectedIcon color="#A684FF" className="w-6" />
            </Group>
            <Stack gap={2}>
               <p className="text-white font-medium text-base">
                  Selected Plan: {selectedTier?.tierName}
               </p>
               <p>
                  {selectedTier?.tierType === 'bundle'
                     ? 'Unlimited Users'
                     : `${selectedTier?.includedSeats} user${
                          selectedTier?.includedSeats === 1 ? '' : 's'
                       }`}
               </p>
            </Stack>
         </Group>
         <Stack className="text-right" gap={0}>
            <p className="text-white font-semibold text-2xl">
               {selectedPriceText}
               <span className="text-[#99A1AF]">/{selectedPeriod}</span>
            </p>
            <p className="text-[#99A1AF] text-sm font-medium">
               +${selectedTier?.setupFee} Build out fee
            </p>
            <p className="text-[#99A1AF] text-sm font-medium">+usage charges</p>
         </Stack>
      </Group>
   )
}
